/**
 * Denials RTK Query tag-type registry (denials module).
 *
 * Mirrors `modules/claims/data/tags.ts`: every tag type is declared up-front here and passed to the
 * single base `createApi` (see `denialsApi.ts`). `injectEndpoints` cannot introduce new tag types,
 * so any tag a feature endpoint provides or invalidates MUST be listed here.
 */
export const DENIALS_TAG_TYPES = [
  'DenialQueue',
  'DenialItem',
  'DenialFullHistory',
  'DenialRules',
  'DenialPacket',
  'DenialLane',
] as const;

export type DenialsTagType = (typeof DENIALS_TAG_TYPES)[number];
